<template>
  <div class="agr">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>

    <div class="container">
      <!-- <h2>自审制度</h2> -->
      <p>
        为加强网络文化内容建设与管理，规范网络文化经营单位产品及服务内容自审工作，增强本公司自主管理能力和自律责任，确保网络文化健康，快速发展，根据《互联网文化管理暂行规定》，结合本单位发展需要，特制定本制度
      </p>
      <h2>自审小组构成：</h2>
      <p>
        公司成立独立于各个业务部门的内容审查小组，小组成员包括技术开发总监、客服部主管、投诉部总监以及运营部总监。由公司总经理负责自审小组的召集和日常运作事宜。自审小组的主要任务是在产品开发过程中规范相关产品内容；在版本验收环节对可能涉及违反法律法规的内容进行自查自纠；在产品运营过程中随时检查各种营销素材、营销活动及其他内容是否有不适当的内容出现。并且一旦发现有违规情况的发生，自审小组负责对相关责任人和部门进行查处惩戒。
      </p>
      <h2>自审人员职责：</h2>
      <p>①本公司审核人员掌握内容审核的相关知识和政策法规；</p>
      <p>
        ②审核人员均可在内容自审这一工作中表达其独立的审核意见；对初审有问题的内容，退回网站编辑人员进行修改，并对修改后的内容进行复查；
      </p>
      <p>
        ③
        审核人员须以最终保证本企业的产品和服务的合法性和合规性为目的，对在自审工作中发现违法违规的产品及服务内容进行记录并提请中止，作出提交修改，督促修改，复审等审核意见。
      </p>
      <p>④审核人员负责保管审查记录；</p>
      <p>⑤审核人员每年至少应当参加1次业务培训；</p>

      <h2>技术安全保障：</h2>

      <p>
        配备专业的维护人员为用户提供服务的系统进行全天候的监控，一旦应用系统发生故障，维护人员可立即解决问题并使系统恢复正常，严格遵守运营商提出的技术要求，在要求的时间内正确处理用户的请求服务，对用户的请求进行响应，并回复给用户请求的内容，保证内容准确无误
      </p>
      <p>
        人工鉴别：
        在运营管理后台中，用户头像、封面照等图片文件皆可查询预览，并对违规的图片进行管理操作。
        如若通过严格的自审制度（自动+人工）之后，网站上仍然存留涉黄、涉恐、涉政、暴力、低俗文字、图片、视频等内容，突发事案处理流程如下：
      </p>

      <p>
        ①技术上掐断处理、保留证据和用户信息，产品立刻下线并进行调整、修改，复审合格后，方可重新上线
      </p>
      <p>
        ②对事态分析。调查、核实内部及外部责任及分析，重新解决方案，并记录在案，相关记录保存至少两年。
      </p>
      <p>③逐级上报上级领导</p>
      <p>
        ④报案处理。含有严重宣扬淫秽、暴力、教唆犯罪或者危害社会公德的内容，违反《互联网文化管理暂行规定》的产品，上报法务部，由法务部报网监局/公安局进行处理
      </p>
      <p>
        ⑤加强内部管理。从部门领导开始，严格学习《互联网文化管理暂行规定》、《网络文化经营单位内容自审管理办法》和《网络漫画经营活动管理办法》等规章制度，信息收集小组在前期搜集视频过程中及签署版权合作协议，严格按照公司制定的审核制度进行，从源头上阻止违规产品流通、上线、传播。
      </p>

      <div class="blink"></div>
    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/h2";
export default {
  name: "agreement",
  components: {
    NavHeader,
  },
  data() {
    return {
      href: "index.html",
    };
  },
  mounted() {
    document.title = "晋江奇境 ";
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.agr {
  .container {
    width: 980px;
    padding-top: 30px;
    h2 {
      font-size: 21px;
      font-weight: bold;
      color: #333;
    }

    p {
      text-indent: 30px;
      font-size: 14px;
      line-height: 31px;
      margin: 20px 0 40px;
      color: #888;
    }

    h3 {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin: 15px 0;
      span {
        font-size: 14px;
        color: #888;
        font-weight: normal;
      }
    }

    .blink {
      width: 100%;
      height: 1px;
      background: #ccc;
      margin-bottom: 30px;
    }
  }
}
</style>
